import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { createContext, useMemo } from 'react';
import { LoadableComponentContextProvider } from '@wix/da-hooks/pkg/useLoadableComponent';
import { EditorContextProviderWrapper } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import { CommentableTypes } from '../Comment/redux/types';
import { CommentEditorSource } from './redux/types';
import { useCommentEditorSpecifics } from './hooks/useCommentEditorSpecifics';
import DraftCommentAutoTrigger from './DraftCommentAutoTrigger';
export const CommentEditorContext = /*#__PURE__*/ createContext({
    // Mostly gibberish defaults
    editorId: '',
    commentableItemId: '',
    commentableType: CommentableTypes.COMMENT_USER,
    isBusy: false,
    shouldFocus: false,
    editorSource: CommentEditorSource.Independent,
    isExpanded: false,
    expandEditor: ()=>null,
    collapseEditor: ()=>null
});
const CommentEditorContextProvider = (_param)=>{
    var { children, commentBoxId, commentableItemId, commentableType, submitValidator } = _param, useCommentEditorOptions = _object_without_properties(_param, [
        "children",
        "commentBoxId",
        "commentableItemId",
        "commentableType",
        "submitValidator"
    ]);
    const { editorSource, isBusy, relevantComment, shouldFocus, isExpanded, expandEditor, collapseEditor, rootElementRef, initialContent } = useCommentEditorSpecifics(commentBoxId, commentableItemId, commentableType, useCommentEditorOptions);
    const memoizedCommentEditorContext = useMemo(()=>({
            editorSource,
            isBusy,
            relevantComment,
            shouldFocus,
            isExpanded,
            expandEditor,
            collapseEditor,
            initialContent,
            rootElementRef,
            editorId: commentBoxId,
            commentableItemId,
            commentableType
        }), [
        editorSource,
        isBusy,
        relevantComment,
        shouldFocus,
        isExpanded,
        expandEditor,
        collapseEditor,
        initialContent,
        rootElementRef,
        commentableItemId,
        commentableType,
        commentBoxId
    ]);
    return /*#__PURE__*/ React.createElement(CommentEditorContext.Provider, {
        value: memoizedCommentEditorContext
    }, children);
};
/**
 * Contains all the context providers we need for a comment editor implementation.
 *
 * Includes: `EditorContext`, `LoadableComponentContext`, and `CommentEditorContext`.
 */ export const CommentEditorProviders = (_param)=>{
    var { children, forceLoadOnMount, commentBoxId, submitValidator } = _param, rest = _object_without_properties(_param, [
        "children",
        "forceLoadOnMount",
        "commentBoxId",
        "submitValidator"
    ]);
    return /*#__PURE__*/ React.createElement(EditorContextProviderWrapper, null, /*#__PURE__*/ React.createElement(LoadableComponentContextProvider, {
        forceLoadOnMount: forceLoadOnMount
    }, /*#__PURE__*/ React.createElement(CommentEditorContextProvider, _object_spread({
        commentBoxId: commentBoxId,
        submitValidator: submitValidator
    }, rest), /*#__PURE__*/ React.createElement(DraftCommentAutoTrigger, {
        editorId: commentBoxId
    }), children)));
};

//# sourceMappingURL=context.js.map